import React, { useState } from "react";
import { Modal } from "newui/components/ui/Modal";
import { InputWithLabel } from "newui/components/ui/InputWithLabel";
import { useMfaDisable } from "../../hooks/useMfaDisable";

export interface DisableMfaModalProps {
	isOpen: boolean;
	onClose: () => void;
	onDisabled: () => void;
}

export const DisableMfaModal = ({ isOpen, onClose, onDisabled }: DisableMfaModalProps) => {
	const [password, setPassword] = useState("");
	const disableMfa = useMfaDisable();

	const handleClose = () => {
		setPassword("");
		disableMfa.reset();
		onClose();
	};

	const handleConfirm = () => {
		disableMfa.mutate(
			{ password },
			{
				onSuccess: () => {
					setPassword("");
					onDisabled();
				},
			}
		);
	};

	return (
		<Modal
			isOpen={isOpen}
			onClose={handleClose}
			title="Disable two-factor authentication"
			description="Your account will no longer require a code at sign-in. Confirm your password to continue."
			iconType="warning"
			modalType="alert"
			closeOnEsc
			primaryButton={{
				text: "Disable",
				btntype: "danger",
				disabled: !password,
				isLoading: disableMfa.isPending,
				onClick: handleConfirm,
			}}
			secondaryButton={{
				text: "Cancel",
				onClick: handleClose,
			}}
		>
			<InputWithLabel
				label="Password"
				type="password"
				icon
				value={password}
				onChange={(e) => setPassword(e.target.value)}
				errorText={disableMfa.error?.message}
				testId="disable-2fa-password-input"
				required
			/>
		</Modal>
	);
};
